import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Mask = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path fill={props.fill} d="M26.369 19.961H15.7v3.581h7.349l3.32-3.581z" />
    <path
      fill="currentColor"
      d="M34.763 24.176V22.46l-6.566 3.208c.522-1.007.821-2.238.821-3.693 0-3.768-2.761-7.125-5.111-9.289L34.8 16.118l-.037-1.641-14.251-4.402V10l-.112.037-.075-.037-.037.075-14.251 4.402L6 16.118l10.893-3.432c-2.35 2.164-5.111 5.521-5.111 9.289 0 1.455.298 2.686.821 3.693L6.075 22.46v1.716l9.625 4.701c1.604.895 3.357 1.268 4.701 1.268 1.306 0 3.096-.373 4.701-1.268l9.662-4.701zM20.4 11.753c1.791 1.306 7.125 5.559 7.125 10.222 0 6.23-6.678 6.64-7.125 6.678-.448-.037-7.125-.41-7.125-6.678 0-4.663 5.335-8.916 7.125-10.222z"
    />
  </svg>
);

export default SvgCovid19Mask;
